import { render, staticRenderFns } from "./WidgetPartners.vue?vue&type=template&id=7eff9c1d"
import script from "./WidgetPartners.vue?vue&type=script&lang=js"
export * from "./WidgetPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports